import { render, staticRenderFns } from "./diagnosisForm.vue?vue&type=template&id=057f5d91&scoped=true"
import script from "./diagnosisForm.vue?vue&type=script&lang=js"
export * from "./diagnosisForm.vue?vue&type=script&lang=js"
import style0 from "./diagnosisForm.vue?vue&type=style&index=0&id=057f5d91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057f5d91",
  null
  
)

export default component.exports